import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, TestZendeskIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof TestZendeskIntegrationResponseDataSchema>>

export function useTestZendeskTicketMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestZendeskIntegrationResponseDataSchema>) => {
      const response = await axios.post<Response>(`/integrations/zendesk/test`, data)

      return response.data.data
    },
  })
}
